module.exports = require("webpackbar");